var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_330_16200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.4 164.17C152.53 164.81 152.47 165.48 152.22 166.09C151.97 166.7 151.55 167.22 151.01 167.58C150.47 167.95 149.83 168.15 149.17 168.15C148.51 168.15 147.87 167.96 147.32 167.6C146.77 167.24 146.34 166.72 146.09 166.12C145.84 165.52 145.77 164.85 145.89 164.21C146.01 163.57 146.33 162.97 146.79 162.51C147.25 162.04 147.84 161.72 148.48 161.59C148.91 161.5 149.35 161.5 149.78 161.58C150.21 161.66 150.62 161.83 150.98 162.07C151.34 162.31 151.66 162.62 151.9 162.98C152.14 163.34 152.31 163.75 152.4 164.18V164.17Z",
    fill: "#001419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.9 153.78C152.17 152.59 153.77 151.8 155.49 151.52C157.21 151.24 158.98 151.47 160.57 152.19C162.16 152.91 163.5 154.09 164.42 155.57C165.34 157.05 165.8 158.77 165.74 160.52C165.68 162.26 165.11 163.95 164.09 165.37C163.07 166.79 161.66 167.87 160.03 168.48C158.4 169.09 156.62 169.21 154.92 168.81C153.22 168.41 151.68 167.52 150.49 166.25C148.89 164.54 148.04 162.27 148.12 159.93C148.2 157.59 149.2 155.38 150.91 153.78H150.9Z",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.06 80.3398L103.16 144.59",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7499 138.521L77.6699 73.3906",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.38 62.9604L128.11 161.39C125.98 169.7 117.8 174.97 109.35 173.48L53.0499 163.55C44.5999 162.06 38.7199 154.31 39.5599 145.78L49.4799 44.6504",
    fill: "#E54839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.89 55.7006L130.05 49.1206C131.54 40.6406 126.25 32.4106 117.82 30.6506C113.88 29.8206 109.91 29.0606 105.92 28.3506C101.93 27.6406 97.9399 27.0106 93.9499 26.4406C85.4299 25.2206 77.6399 31.1406 76.1399 39.6206L74.9799 46.2006",
    fill: "#E54839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.06 80.3398L103.16 144.59",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7499 138.521L77.6699 73.3906",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.38 62.9604L128.11 161.39C125.98 169.7 117.8 174.97 109.35 173.48L53.0499 163.55C44.5999 162.06 38.7199 154.31 39.5599 145.78L49.4799 44.6504",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.89 55.7006L130.05 49.1206C131.54 40.6406 126.25 32.4106 117.82 30.6506C113.88 29.8206 109.91 29.0606 105.92 28.3506C101.93 27.6406 97.9399 27.0106 93.9499 26.4406C85.4299 25.2206 77.6399 31.1406 76.1399 39.6206L74.9799 46.2006",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9199 44.5312C44.4399 44.5312 46.9499 44.5713 49.4799 44.6313C57.9399 44.8413 66.4399 45.3612 74.9799 46.1912C83.9999 47.0712 93.0499 48.3113 102.12 49.9113C111.19 51.5113 120.12 53.4413 128.89 55.7013C137.2 57.8413 145.36 60.2613 153.38 62.9613C155.77 63.7612 158.15 64.5912 160.52 65.4512L41.9199 44.5413V44.5312Z",
    fill: "#00C707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9199 44.5312C44.4399 44.5312 46.9499 44.5713 49.4799 44.6313C57.9399 44.8413 66.4399 45.3612 74.9799 46.1912C83.9999 47.0712 93.0499 48.3113 102.12 49.9113C111.19 51.5113 120.12 53.4413 128.89 55.7013C137.2 57.8413 145.36 60.2613 153.38 62.9613C155.77 63.7612 158.15 64.5912 160.52 65.4512",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9199 44.5312C44.4399 44.5312 46.9499 44.5713 49.4799 44.6313C57.9399 44.8413 66.4399 45.3612 74.9799 46.1912C83.9999 47.0712 93.0499 48.3113 102.12 49.9113C111.19 51.5113 120.12 53.4413 128.89 55.7013C137.2 57.8413 145.36 60.2613 153.38 62.9613C155.77 63.7613 158.15 64.5912 160.52 65.4512L41.9199 44.5413V44.5312Z",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8899 88.2991C60.8899 91.3991 59.9699 94.4291 58.2499 97.0091C56.5299 99.5891 54.0799 101.599 51.2099 102.789C48.3399 103.979 45.1899 104.289 42.1499 103.679C39.1099 103.069 36.3099 101.579 34.1199 99.3891C31.9299 97.1991 30.4299 94.3991 29.8299 91.3591C29.2199 88.3191 29.5399 85.1591 30.7199 82.2991C31.9099 79.4291 33.9199 76.9891 36.4999 75.2591C39.0799 73.5291 42.1099 72.6191 45.2099 72.6191C49.3699 72.6191 53.3599 74.2791 56.2999 77.2191C59.2399 80.1591 60.8899 84.1491 60.8999 88.3091L60.8899 88.2991Z",
    fill: "#001419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8899 88.2991C60.8899 91.3991 59.9699 94.4291 58.2499 97.0091C56.5299 99.5891 54.0799 101.599 51.2099 102.789C48.3399 103.979 45.1899 104.289 42.1499 103.679C39.1099 103.069 36.3099 101.579 34.1199 99.3891C31.9299 97.1991 30.4299 94.3991 29.8299 91.3591C29.2199 88.3191 29.5399 85.1591 30.7199 82.2991C31.9099 79.4291 33.9199 76.9891 36.4999 75.2591C39.0799 73.5291 42.1099 72.6191 45.2099 72.6191C49.3699 72.6191 53.3599 74.2791 56.2999 77.2191C59.2399 80.1591 60.8899 84.1491 60.8999 88.3091L60.8899 88.2991Z",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.21 84.3008L41.21 92.3008",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.21 84.3008L49.21 92.3008",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.19 24.75L150.42 31.82L155.78 30.87L154.01 37.94",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_330_16200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteImage);
export default __webpack_public_path__ + "static/media/delete-image.dd7c2b23fa58dd02608b09c735784e75.svg";
export { ForwardRef as ReactComponent };